// extracted by mini-css-extract-plugin
export default {"brandPromo":"YG-z","carousel":"ZG-z"};